var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    width: 30,
    fill: "#22428F",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.91,16H37.09C34.84,16,33,17.84,33,20.09V26h-5.91C24.84,26,23,27.84,23,30.09v47.82c0,2.26,1.84,4.09,4.09,4.09h37.82   c2.26,0,4.09-1.84,4.09-4.09V72h5.91c2.26,0,4.09-1.84,4.09-4.09V20.09C79,17.84,77.16,16,74.91,16z M67,77.91   c0,1.15-0.94,2.09-2.09,2.09H27.09C25.94,80,25,79.06,25,77.91V30.09c0-1.15,0.94-2.09,2.09-2.09h37.82c1.15,0,2.09,0.94,2.09,2.09   V77.91z M77,67.91c0,1.15-0.94,2.09-2.09,2.09H69V30.09c0-2.26-1.84-4.09-4.09-4.09H35v-5.91c0-1.15,0.94-2.09,2.09-2.09h37.82   c1.15,0,2.09,0.94,2.09,2.09V67.91z",
    stroke: "#22428F",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.28e6db73fa6e66935d1a5ec1512a736c.svg";
export { ForwardRef as ReactComponent };